/**
 * 顯示PSU區塊的learn more重新定位
 */
const {q, qa} = require('../libs/simpleQuery');
const site = require('../utilities/site');
const psuLinkReg = /gigabyte.com\/(.*Power-Supply)$/i;
const UrlCountryCode = window.UrlCountryCode || "";
const redirectUrl = `https://www.gigabyte.com${UrlCountryCode}/MicroSite/139/`;
const productpage = require('../utilities/ProductPage');
const ProductLineReg = /(gigabyte\.(com|cn|ru)|aorus.com)\/[^\/]*\/?Graphics-Cards?/i

//
if(
    ProductLineReg.test(location.href) //匹配官網顯卡網址
    && site.KFContainer != null //匹配產品頁框架
    && productpage.getPid() != null //匹配產品頁PID
){
    qa('a[href]', site.KFContainer).forEach(a => {
        var href = a.getAttribute('href');
        if(psuLinkReg.test(href)){
            a.setAttribute('href', redirectUrl);
        }
    });
}